import { GameConfig, Theme } from '../types';

export const GAME_CONFIG: GameConfig = {
  TIMER_SECONDS: 30,
  BASE_SCORE: 10,
  TIME_BONUS_MULTIPLIER: 2,
  COMBO_BONUS_MULTIPLIER: 5,
  COMBO_THRESHOLD: 3,
  ACHIEVEMENTS: {
    FIRST_WORD: '🌟 First Word!',
    STREAK_5: '🔥 5 Streak!',
    COMBO_MASTER: '⚡ Combo Master!',
    CENTURY: '💯 Century!'
  }
};

export const THEMES: Theme[] = [
  { name: 'Animals', displayName: '动物', emoji: '🦁' },
  { name: 'Fruit', displayName: '水果', emoji: '🍎' },
  { name: 'Colors', displayName: '颜色', emoji: '🌈' },
  { name: 'School', displayName: '学校', emoji: '🏫' },
  { name: 'Family', displayName: '家庭', emoji: '👨‍👩‍👧‍👦' },
  { name: 'Weather', displayName: '天气', emoji: '☀️' },
  { name: 'Body Parts', displayName: '身体部位', emoji: '👤' },
  { name: 'Toys', displayName: '玩具', emoji: '🎮' },
  { name: 'Space', displayName: '太空', emoji: '🚀' }
];

export const CHAT_GREETINGS = [
  "Hello! I'm Panda Teacher! Ready for our English adventure? 🐼",
  "Hi there! Let's learn English together! What's your name? 🌟",
  "Welcome! Panda Teacher is here to help you learn! 📚",
  "Hey! Want to practice English with me today? 🎮"
];

export const AI_CONFIG = {
  MODEL: 'deepseek-ai/DeepSeek-V3',
  API_URL: 'https://api.siliconflow.cn/v1/chat/completions',
  TEMPERATURE: 0.7,
  MAX_TOKENS: 1000,
  VOICE: 'en-US-AvaNeural'
};

export const TTS_CONFIG = {
  VOICE: 'en-US-AvaNeural',
  SPEED: 0.9,
  PITCH: 1,
  STYLE: 'general',
  ROLE: 'default'
};

export const APP_CONFIG = {
  NAME: 'China Kid Learn English',
  VERSION: '1.0.0',
  DESCRIPTION: 'Interactive English learning app for Chinese children'
};